export default "__VITE_ASSET__CbESuYQj__"